export const HISTORY_ROUTES = {
  "Recebido-Em Processamento": [
    [2370,3150],
    [2334,3150],
    [1758,3156],
    [1761,3075],
    [1978,3075],
    [2117,3067],
    [2147,3067],
    [2171,3078],
    [2258,3078],
    [2485,3043],
    [2439,2528],
    [2436,2419],
    [1769,2420],
    [1768,2470],
    [1730,2470],
    [1730,2485],
    [1216,2485],
    [1284,1993],
    [1850,1993],
  ],
  "Recebido-Pendência Técnica":[
    [2370,3150],
    [2925,3150],
    [2890,2940],
    [3150,2940],
    [3125,2792],
    [3160,2792],
  ],
  "Recebido-Recoleta":[
    [2370,3150],
    [2925,3150],
    [2890,2940],
    [3150,2940],
    [3100,2665],
    [3310,2665]
  ],
  "Recebido-Em Análise Técnica":[
    [2370,3150],
    [2334,3150],
    [1758,3156],
    [1761,3075],
    [1978,3075],
    [2117,3067],
    [2147,3067],
    [2171,3078],
    [2258,3078],
    [2485,3043],
    [2439,2528],
    [2436,2419],
    [1769,2420],
    [1768,2470],
    [1730,2470],
    [1730,2485],
    [1216,2485],
    [1346,1507],
    [1650,1506],
    [1671,1160],
    [2090,1160],
    [2090,1020],
    [2044,1020]
  ],
  "Recebido-Resultado Liberado":[
    [2370,3150],
    [1755,3151],
    [1766,3073],
    [1988,3073],
    [2107,3066],
    [2143,3065],
    [2170,3076],
    [2258,3077],
    [2458,3047],
    [2485,3046],
    [2439,2537],
    [2435,2419],
    [1770,2420],
    [1768,2486],
    [1217,2485],
    [1346,1507],
    [1650,1506],
    [1671,1160],
    [2397,1160],
    [2383,1020],
    [2343,1020],
  ],
  
  "Em Processamento-Em Análise Técnica":[
      [1850,1993],
      [1284,1992],
      [1346,1505],
      [1650,1505],
      [1671,1180],
      [2100,1180],
      [2100,1020],
      [2044,1020]
  ],
  "Em Processamento-Pendência Técnica":[
    [1850,1993],
    [1955,1993],
    [1955,2200],
    [2489,2200],
    [2502,2354],
    [2550,2354],
    [2558,2455],
    [2638,2454],
    [2706,3015],
    [2900,3015],
    [2890,2940],
    [3155,2940],
    [3125,2795],
    [3125,2792],
    [3160,2792],
  ],
  "Em Processamento-Recoleta":[
    [1850,1993],
    [1955,1993],
    [1955,2200],
    [2489,2200],
    [2502,2354],
    [2550,2354],
    [2558,2455],
    [2638,2454],
    [2706,3015],
    [2900,3015],
    [2890,2940],
    [3155,2940],
    [3125,2795],
    [3100,2665],
    [3310,2665],
  ],
  "Em Processamento-Resultado Liberado":[
    [1850,1993],
    [1284,1992],
    [1345,1508],
    [1650,1506],
    [1671,1160],
    [2397,1160],
    [2383,1020],
    [2343,1020],
  ],

  "Pendência Técnica-Em Processamento":[
    [3160,2792],
    [3125,2792],
    [3125,2795],
    [3155,2940],
    [2890,2940],
    [2900,3015],
    [2706,3015],
    [2638,2454],
    [2558,2455],
    [2550,2354],
    [2502,2354],
    [2489,2200],
    [1955,2200],
    [1955,1993], 
    [1850,1993],
  ],
  "Pendência Técnica-Em Análise Técnica":[
    [3160,2792],
    [3125,2792],
    [3125,2795],
    [3155,2940],
    [2890,2940],
    [2900,3015],
    [2706,3015],
    [2638,2454],
    [2558,2455],
    [2550,2354],
    [2502,2354],
    [2489,2200],
    [1955,2200],
    [1950,1170],
    [2100,1170],
    [2100,1020],
    [2044,1020],
  ],
  "Pendência Técnica-Recoleta":[
   [3160,2792],
   [3142,2792],
   [3120,2685],
   [3315,2685],
   [3310,2665],   
  ],
  "Pendência Técnica-Resultado Liberado":[
    [3160,2792],
    [3125,2792],
    [3125,2795],
    [3155,2940],
    [2890,2940],
    [2900,3015],
    [2706,3015],
    [2638,2454],
    [2558,2455],
    [2550,2354],
    [2502,2354],
    [2489,2200],
    [1955,2200],
    [1950,1170],
    [2397,1170],
    [2383,1020],
    [2343,1020],
  ],

  "Recoleta-Pendência Técnica":[
    [3310,2665],
    [3315,2685],
    [3120,2685],
    [3142,2792],
    [3160,2792],
  ],
  "Recoleta-Em Processamento":[
    [3310,2665],
    [3100,2665],
    [3125,2795],
    [3155,2940],
    [2890,2940],
    [2900,3015],
    [2706,3015],
    [2638,2454],
    [2558,2455],
    [2550,2354],
    [2502,2354],
    [2489,2200],
    [1955,2200],
    [1955,1993], 
    [1850,1993],
  ],
  "Recoleta-Em Análise Técnica":[
    [3310,2665],
    [3100,2665],
    [3125,2795],
    [3155,2940],
    [2890,2940],
    [2900,3015],
    [2706,3015],
    [2638,2454],
    [2558,2455],
    [2550,2354],
    [2502,2354],
    [2489,2200],
    [1955,2200],
    [1950,1170],
    [2100,1170],
    [2100,1020],
    [2044,1020],
  ],
  "Recoleta-Resultado Liberado":[
    [3310,2665],
    [3100,2665],
    [3125,2795],
    [3155,2940],
    [2890,2940],
    [2900,3015],
    [2706,3015],
    [2638,2454],
    [2558,2455],
    [2550,2354],
    [2502,2354],
    [2489,2200],
    [1955,2200],
    [1950,1170],
    [2397,1170],
    [2383,1020],
    [2343,1020],
  ],

  "Em Análise Técnica-Resultado Liberado":[
    [2044,1020],
    [2343,1020],
  ],
  "Em Análise Técnica-Pendência Técnica":[
    [2044,1020],
    [2100,1020],
    [2100,1170],
    [1950,1170],
    [1955,2200],
    [2489,2200],
    [2502,2354],
    [2550,2354],
    [2558,2455],
    [2638,2454],
    [2706,3015],
    [2900,3015],
    [2890,2940],
    [3155,2940],
    [3125,2795],
    [3125,2792],
    [3160,2792],
  ],
  "Em Análise Técnica-Recoleta":[
    [2044,1020],
    [2100,1020],
    [2100,1170],
    [1950,1170],
    [1955,2200],
    [2489,2200],
    [2502,2354],
    [2550,2354],
    [2558,2455],
    [2638,2454],
    [2706,3015],
    [2900,3015],
    [2890,2940],
    [3155,2940],
    [3125,2795],
    [3100,2665],
    [3310,2665],
  ]
}
export const HISTORY_ROUTES_FLAT = {
  "Recebido-Em Processamento": [
      [2452,3736],
      [1856,3736],
      [1856,3655],
      [2573,3655],
      [2573,2970],
      [1848,2970],
      [1848,3006],
      [1226,3006],
      [1226,2341],
      [1919,2341],
  ],
  "Recebido-Pendência Técnica":[
    [2452,3736],
    [3010,3736],
    [3010,3500],
    [3233,3500],
    [3230,3357],
    [3322,3357],
  ],
  "Recebido-Recoleta":[
    [2452,3736],
    [3010,3736],
    [3010,3500],
    [3233,3500],
    [3233,3212],
    [3512,3212],
  ],
  "Recebido-Em Análise Técnica":[
    [2452,3736],
    [1856,3736],
    [1856,3655],
    [2573,3655],
    [2573,2970],
    [1848,2970],
    [1848,3006],
    [1226,3006],
    [1226,1548],
    [1634,1548],
    [1634,880],
    [2260,880],
    [2260,510],
    [2180,510],
  ],
  "Recebido-Resultado Liberado":[
    [2452,3736],
    [1856,3736],
    [1856,3655],
    [2573,3655],
    [2573,2970],
    [1848,2970],
    [1848,3006],
    [1226,3006],
    [1226,1548],
    [1634,1548],
    [1634,880],
    [2702,880],
    [2696,512],
    [2628,512]
  ],

  "Em Processamento-Em Análise Técnica":[
      [1919,2341],
      [1225,2341],
      [1225,1545],
      [1635,1545],
      [1635,880],
      [2260,880],
      [2260,510],
      [2180,510],
  ],
  "Em Processamento-Recoleta":[
    [1920,2341],
    [2066,2341],
    [2066,2646],
    [2670,2646],
    [2670,2826],
    [2737,2826],
    [2737,2956],
    [2810,2956],
    [2810,3610],
    [3010,3610],
    [3010,3500],
    [3233,3500],
    [3233,3212],
    [3512,3212],
  ],
  "Em Processamento-Pendência Técnica":[
    [1920,2341],
    [2066,2341],
    [2066,2646],
    [2670,2646],
    [2670,2826],
    [2737,2826],
    [2737,2956],
    [2810,2956],
    [2810,3610],
    [3010,3610],
    [3010,3500],
    [3233,3500],
    [3233,3357],
    [3322,3357],
  ],
  "Em Processamento-Resultado Liberado":[
    [1919,2341],
    [1226,2341],
    [1226,1548],
    [1634,1548],
    [1634,880],
    [2702,880],
    [2696,512],
    [2628,512]
  ],

  "Pendência Técnica-Em Processamento":[
    [3322,3357],
    [3233,3357],
    [3233,3500],
    [3010,3500],
    [3010,3610],
    [2810,3610],
    [2810,2956],
    [2737,2956],
    [2737,2826],
    [2670,2826],
    [2670,2646],
    [2066,2646],
    [2066,2341],
    [1920,2341],
  ],
  "Pendência Técnica-Em Análise Técnica":[
    [3322,3357],
    [3233,3357],
    [3233,3500],
    [3010,3500],
    [3010,3610],
    [2810,3610],
    [2810,2956],
    [2737,2956],
    [2737,2826],
    [2670,2826],
    [2670,2646],
    [2066,2646],
    [2066,880],
    [2280,880],
    [2280,510],
    [2180,510],
  ],
  "Pendência Técnica-Recoleta":[
    [3322,3357],
    [3253,3357],
    [3253,3230],
    [3512,3230],
    [3512,3212],
  ],
  "Pendência Técnica-Resultado Liberado":[
    [3322,3357],
    [3233,3357],
    [3233,3500],
    [3010,3500],
    [3010,3610],
    [2810,3610],
    [2810,2956],
    [2737,2956],
    [2737,2826],
    [2670,2826],
    [2670,2646],
    [2066,2646],
    [2066,880],
    [2702,880],
    [2696,512],
    [2628,512]
  ],

  "Recoleta-Em Processamento":[
    [3512,3212],
    [3233,3212],
    [3233,3500],
    [3010,3500],
    [3010,3610],
    [2810,3610],
    [2810,2956],
    [2737,2956],
    [2737,2826],
    [2670,2826],
    [2670,2646],
    [2066,2646],
    [2066,2341],
    [1920,2341],
  ],
  "Recoleta-Em Análise Técnica":[
    [3512,3212],
    [3233,3212],
    [3233,3500],
    [3010,3500],
    [3010,3610],
    [2810,3610],
    [2810,2956],
    [2737,2956],
    [2737,2826],
    [2670,2826],
    [2670,2646],
    [2066,2646],
    [2066,880],
    [2280,880],
    [2280,510],
    [2180,510],
  ],
  "Recoleta-Pendência Técnica":[
    [3512,3212],
    [3512,3230],
    [3253,3230],
    [3253,3357],
    [3322,3357],
  ],
  "Recoleta-Resultado Liberado":[
    [3512,3212],
    [3233,3212],
    [3233,3500],
    [3010,3500],
    [3010,3610],
    [2810,3610],
    [2810,2956],
    [2737,2956],
    [2737,2826],
    [2670,2826],
    [2670,2646],
    [2066,2646],
    [2066,880],
    [2702,880],
    [2696,512],
    [2628,512]
  ],

  "Em Análise Técnica-Resultado Liberado":[
      [2180,510],
      [2628,512]
  ],
  "Em Análise Técnica-Pendência Técnica":[
    [2180,510],
    [2280,510],
    [2280,900],
    [2066,900],
    [2066,2646],
    [2670,2646],
    [2670,2826],
    [2737,2826],
    [2737,2956],
    [2810,2956],
    [2810,3610],
    [3010,3610],
    [3010,3500],
    [3233,3500],
    [3233,3357],
    [3322,3357],
  ],
  "Em Análise Técnica-Recoleta":[
    [2180,510],
    [2280,510],
    [2280,900],
    [2066,900],
    [2066,2646],
    [2670,2646],
    [2670,2826],
    [2737,2826],
    [2737,2956],
    [2810,2956],
    [2810,3610],
    [3010,3610],
    [3010,3500],
    [3233,3500],
    [3233,3212],
    [3512,3212],
  ]
}

export const HISTORY_ROUTES_GENERIC = {
  "Recebido-Em Processamento": [
    [2343,3484],
    [1510,3480],
    [1510,3360],
    [1830,3360],
    [1970,3350],
    [2260,3350],
    [2570,3330],
    [2545,2924],
    [2520,2550],
    [2520,2380],
    [2140,2380],
    [2140,2470],
    [1340,2470],
    [1412,1756],
    [1939,1753],
  ],
  "Recebido-Recoleta":[
    [2343,3484],
    [1510,3480],
    [1510,3360],
    [1830,3360],
    [1970,3350],
    [2260,3350],
    [2570,3330],
    [2546,2924],
    [2533,2732],
    [2910,2732]
  ],
  "Recebido-Pendência Técnica":[
    [2343,3484],
    [1510,3480],
    [1510,3360],
    [1830,3360],
    [1970,3350],
    [2260,3350],
    [2570,3330],
    [2546,2924],
    [2660,2924]
  ],
  "Recebido-Em Análise Técnica":[
    [2343,3484],
    [1510,3480],
    [1510,3360],
    [1830,3360],
    [1970,3350],
    [2260,3350],
    [2570,3330],
    [2545,2924],
    [2520,2550],
    [2520,2380],
    [2140,2380],
    [2140,2470],
    [1340,2470],
    [1412,1756],
    [1482,1070],
    [1905,1070],
    [1914,770],
    [1810,770]
  ],
  "Recebido-Resultado Liberado":[
    [2343,3484],
    [1510,3480],
    [1510,3360],
    [1830,3360],
    [1970,3350],
    [2260,3350],
    [2570,3330],
    [2545,2924],
    [2520,2550],
    [2520,2380],
    [2140,2380],
    [2140,2470],
    [1340,2470],
    [1412,1756],
    [1482,1070],
    [1905,1070],
    [1914,770],
    [2095,770]
  ],

  "Em Processamento-Em Análise Técnica":[
    [1939,1753],
    [1412,1753],
    [1482,1070],
    [1905,1070],
    [1914,770],
    [1810,770]
  ],
  "Em Processamento-Resultado Liberado":[
    [1939,1753],
    [1412,1753],
    [1482,1070],
    [1905,1070],
    [1914,770],
    [2095,770]
  ],
  "Em Processamento-Recoleta":[
    [1939,1753],
    [2325,1753],
    [2330,1870],
    [2555,1870],
    [2600,2735],
    [2905,2735],
  ],
  "Em Processamento-Pendência Técnica" :[
   [1939,1753],
   [2325,1753],
   [2330,1870],
   [2555,1870],
   [2600,2924],
   [2660,2924],
  ],

  "Pendência Técnica-Em Processamento" :[
   [2660,2924],
   [2600,2924],
   [2555,1870],
   [2330,1870],
   [2325,1753],
   [1939,1753],
  ],
  "Pendência Técnica-Recoleta":[
   [2660,2924],
   [2610,2924],
   [2600,2755],
   [2910,2755],
   [2905,2730],   
  ],
  "Pendência Técnica-Em Análise Técnica":[
   [2660,2924],
   [2600,2924],
   [2555,1870],
   [2307,1870],
   [2263,770],
   [1810,770],
  ],
  "Pendência Técnica-Resultado Liberado":[
   [2660,2924],
   [2600,2924],
   [2555,1870],
   [2307,1870],
   [2263,770],
   [2095,770],
  ],

  "Recoleta-Pendência Técnica":[
    [2905,2730],
    [2910,2755],
    [2600,2755],
    [2610,2924],
    [2660,2924],
  ],
  "Recoleta-Em Processamento":[
   [2905,2735],
   [2600,2735],
   [2555,1870],
   [2330,1870],
   [2325,1753],
   [1939,1753],
  ],
  "Recoleta-Em Análise Técnica":[
   [2905,2735],
   [2600,2735],
   [2555,1870],
   [2307,1870],
   [2263,770],
   [1810,770],
  ],
  "Recoleta-Resultado Liberado":[
   [2905,2735],
   [2600,2735],
   [2555,1870],
   [2307,1870],
   [2263,770],
   [2095,770],
  ],

  "Em Análise Técnica-Resultado Liberado":[
      [1810,770],
      [2095,770]
  ], 
  "Em Análise Técnica-Pendência Técnica":[
    [1810,770],
    [2263,770],
    [2307,1870],
    [2555,1870],
    [2600,2924],
    [2660,2924],
  ],
  "Em Análise Técnica-Recoleta":[
    [1810,770],
    [2263,770],
    [2307,1870],
    [2555,1870],
    [2600,2735],
    [2905,2735]
  ]
}
export const HISTORY_ROUTES_FLAT_GENERIC = {
  "Recebido-Em Processamento": [
      [2280,3674],
      [1590,3670],
      [1590,3575],
      [2423,3575],
      [2423,2760],
      [2090,2760],
      [2090,2800],
      [1350,2800],
      [1350,2010],
      [1890,2010],
  ],
  "Recebido-Recoleta":[
    [2280,3674],
    [1590,3670],
    [1590,3575],
    [2423,3575],
    [2423,3053],
    [2766,3053]
  ],
  "Recebido-Pendência Técnica":[
    [2280,3674],
    [1590,3670],
    [1590,3575],
    [2423,3575],
    [2423,3225],
    [2534,3225]
  ],
  "Recebido-Em Análise Técnica":[
    [2280,3674],
    [1590,3670],
    [1590,3575],
    [2423,3575],
    [2423,2760],
    [2090,2760],
    [2090,2800],
    [1350,2800],
    [1350,2010],
    [1350,1070],
    [1840,1070],
    [1840,580],
    [1706,580],
  ],
  "Recebido-Resultado Liberado":[
    [2280,3674],
    [1590,3670],
    [1590,3575],
    [2423,3575],
    [2423,2760],
    [2090,2760],
    [2090,2800],
    [1350,2800],
    [1350,2010],
    [1350,1070],
    [1840,1070],
    [1840,580],
    [2062,580],
  ],

  "Em Processamento-Em Análise Técnica":[
    [1889,2004],
    [1350,2004],
    [1350,1070],
    [1840,1070],
    [1840,580],
    [1706,580],
  ],
  "Em Processamento-Resultado Liberado":[
    [1889,2004],
    [1350,2004],
    [1350,1070],
    [1840,1070],
    [1840,580],
    [2062,580],
  ],
  "Em Processamento-Pendência Técnica":[
    [1889,2004],
    [2255,2004],
    [2255,2133],
    [2500,2133],
    [2500,3225],
    [2534,3225],
  ],
  "Em Processamento-Recoleta":[
    [1889,2004],
    [2255,2004],
    [2255,2133],
    [2500,2133],
    [2500,3053],
    [2766,3053],
  ],

  "Pendência Técnica-Em Processamento":[
    [2534,3225],
    [2500,3225],
    [2500,2133],
    [2255,2133],
    [2255,2010],
    [1889,2010],
  ],
  "Pendência Técnica-Em Análise Técnica":[
    [2534,3225],
    [2500,3225],
    [2500,2133],
    [2280,2133],
    [2280,580],
    [1706,580],
  ],
  "Pendência Técnica-Resultado Liberado":[
    [2534,3225],
    [2500,3225],
    [2500,2133],
    [2280,2133],
    [2280,580],
    [2062,580],
  ],
  "Pendência Técnica-Recoleta":[
    [2534,3225],
    [2500,3225],
    [2500,3070],
    [2766,3070],
    [2766,3053],
  ],

  "Recoleta-Em Processamento":[
    [2766,3053],
    [2500,3053],
    [2500,2133],
    [2255,2133],
    [2255,2010],
    [1889,2010],
  ],
  "Recoleta-Em Análise Técnica":[
    [2766,3053],
    [2500,3053],
    [2500,2133],
    [2280,2133],
    [2280,580],
    [1706,580],
  ],
  "Recoleta-Resultado Liberado":[
    [2766,3053],
    [2500,3053],
    [2500,2133],
    [2280,2133],
    [2280,580],
    [2062,580],
  ],
  "Recoleta-Pendência Técnica":[
    [2766,3053],
    [2766,3070],
    [2500,3070],
    [2500,3225],
    [2534,3225],
  ],

  "Em Análise Técnica-Resultado Liberado":[
    [1706,580],
    [2062,580],
  ], 
  "Em Análise Técnica-Pendência Técnica":[
    [1706,580],
    [2280,580],
    [2280,2133],
    [2500,2133],
    [2500,3225],
    [2534,3225],
  ],
  "Em Análise Técnica-Recoleta":[
    [1706,580],
    [2280,580],
    [2280,2133],
    [2500,2133],
    [2500,3053],
    [2766,3053],
  ],
}